export default __webpack_public_path__ + "static/media/PL.659e925a.png";